import { useRouteError } from "react-router-dom";

function ErrorBoundary() {
  let error = useRouteError();
  // console.log("ReferenceError", error);
  // Uncaught ReferenceError: path is not defined
  return <div>{error?.message}</div>;
}
export default ErrorBoundary;
